<template>
  <span :class="cssClass.parent" @click="click">
    <object
      type="image/svg+xml"
      :class="cssClass.icon"
      :width="iconSize"
      :height="iconSize"
    ></object>
  </span>
</template>
<script>
export default {
  props: {
    radius: {
      type: Boolean,
      required: false
    },
    size: {
      type: [Number, String],
      required: false
    },
    variant: {
      type: String,
      required: false
    }
  },
  computed: {
    cssClass() {
      return {
        icon: {
          'c-icon': true,
          ['c-icon--' + this.variant]: this.variant
        },
        parent: {
          'c-icon--radius': this.radius
        }
      };
    },
    iconSize() {
      return this.size + 'px';
    }
  },
  methods: {
    click(e) {
      this.$emit('click', e);
    }
  }
};
</script>
